var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("side-panel", {
    attrs: { loading: _vm.loading },
    on: {
      close: function($event) {
        return _vm.close()
      }
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            !_vm.bonusid
              ? _c("h3", { staticClass: "mt-0 clearfix" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$l10n.__("Ajouter une remise")) +
                      "\n        "
                  )
                ])
              : _c("h3", { staticClass: "mt-0 clearfix" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$l10n.__("Editer une remise")) +
                      "\n        "
                  )
                ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "el-form",
              {
                ref: "bonusForm",
                attrs: {
                  "label-position": "top",
                  model: _vm.bonus,
                  "inline-message": true,
                  "label-width": "120px"
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.reference"),
                      prop: "ref",
                      error: _vm.errors.get("ref")
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        "data-bot": "bonus-form--reference",
                        value: _vm.bonus.ref
                      },
                      model: {
                        value: _vm.bonus.ref,
                        callback: function($$v) {
                          _vm.$set(_vm.bonus, "ref", $$v)
                        },
                        expression: "bonus.ref"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.name"),
                      prop: "name",
                      error: _vm.errors.get("name")
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        "data-bot": "bonus-form--name",
                        value: _vm.bonus.name
                      },
                      model: {
                        value: _vm.bonus.name,
                        callback: function($$v) {
                          _vm.$set(_vm.bonus, "name", $$v)
                        },
                        expression: "bonus.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.description"),
                      prop: "name",
                      error: _vm.errors.get("description")
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        "data-bot": "bonus-form--description",
                        type: "textarea",
                        rows: 2,
                        value: _vm.bonus.description
                      },
                      model: {
                        value: _vm.bonus.description,
                        callback: function($$v) {
                          _vm.$set(_vm.bonus, "description", $$v)
                        },
                        expression: "bonus.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("bonus.BonusForm.unit"),
                              prop: "name",
                              error: _vm.errors.get("unit")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { "data-bot": "bonus-form--unit" },
                                model: {
                                  value: _vm.bonus.unit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.bonus, "unit", $$v)
                                  },
                                  expression: "bonus.unit"
                                }
                              },
                              _vm._l(_vm.units, function(unit) {
                                return _c("el-option", {
                                  key: unit.id,
                                  attrs: { label: unit.value, value: unit.id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.amount"),
                              prop: "name",
                              error: _vm.errors.get("amount")
                            }
                          },
                          [
                            _c("input-number", {
                              attrs: {
                                "data-bot": "bonus-form--amount",
                                value: _vm.bonus.amount,
                                controls: false,
                                precision: _vm.numberFormat.precision,
                                "separator-decimal": _vm.numberFormat.decimal,
                                "separator-thousand": _vm.numberFormat.thousand
                              },
                              model: {
                                value: _vm.bonus.amount,
                                callback: function($$v) {
                                  _vm.$set(_vm.bonus, "amount", $$v)
                                },
                                expression: "bonus.amount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t.__("common.labels.accounting_code"),
                      prop: "name",
                      error: _vm.errors.get("acodeId")
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "wp-6",
                        attrs: { "data-bot": "bonus-form--account-code" },
                        model: {
                          value: _vm.bonus.acodeId,
                          callback: function($$v) {
                            _vm.$set(_vm.bonus, "acodeId", $$v)
                          },
                          expression: "bonus.acodeId"
                        }
                      },
                      [
                        _c("el-option", {
                          key: null,
                          attrs: {
                            label: _vm.$t.__("bonus.BonusForm.default"),
                            value: null
                          }
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.acodes, function(code) {
                          return _c("el-option", {
                            key: code.id,
                            attrs: {
                              label: code.code + " : " + code.label,
                              value: code.id
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              [
                _c("CompassButton", {
                  attrs: { label: _vm.$t.__("common.actions.save") },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.save($event)
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }